<template>
    <div class="p-6 mb-8 bg-white rounded-lg lg:p-8">
        <p class="mb-6 text-xl font-bold text-primary-500">VIII. Vaccinations ワクチン接種</p>
        
        <p class="mb-5 text-darkgray-800">Please list down vaccines you have received in the table below: 以下の表に、これまでに接種したワクチンを記入してください。</p>
        
        <div 
            class="grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-4 bg-primary-50 rounded-2xl p-5 lg:p-7 mb-2" 
            v-for="(vaccination, index) in item" :key="index"
        >
            <div v-if="index >= 1" class="col-span-full text-right">
                <small v-if="!disableInputs" @click="remove(index)" class="text-red-500 cursor-pointer text-sm">Remove</small>
            </div>
            
            <div class="col-span-full lg:col-span-3">
                <text-input
                    v-model="vaccination.vaccine_type"
                    :id="`vaccine-type-${index}`"
                    type="text"
                    placeholder="Type of Vaccine ワクチンの種類"
                    :disabled="disableInputs"
                    :error="errors[`vaccinations_history.${index}.vaccine_type`] ? errors[`vaccinations_history.${index}.vaccine_type`][0] : ''"
                />
            </div>
            
            <div class="col-span-full lg:col-span-3">
                <text-input
                    v-model="vaccination.brand_name"
                    :id="`brand-name-${index}`"
                    type="text"
                    placeholder="Brand ブランド名"
                    :disabled="disableInputs"
                    :error="errors[`vaccinations_history.${index}.brand_name`] ? errors[`vaccinations_history.${index}.brand_name`][0] : ''"
                />
            </div>
            
            <div class="col-span-full lg:col-span-3">
                <text-input
                    v-model="vaccination.number_of_doses"
                    :id="`doses-${index}`"
                    type="text"
                    placeholder="Number of Doses 接種回数"
                    :disabled="disableInputs"
                    @keypress="onKeypressNumbersOnly"
                    @paste="onPasteNumbersOnly"
                    :error="errors[`vaccinations_history.${index}.number_of_doses`] ? errors[`vaccinations_history.${index}.number_of_doses`][0] : ''"
                />
            </div>
            
            <div class="col-span-full lg:col-span-3">
                <CalendarPicker 
                    :disabled="disableInputs"
                    :key="vaccination.date_received"
                    v-model="vaccination.date_received"
                    :id="`date-received-${index}`"
                    :inline="false"
                    placeholder="Date Received 接種日"
                    isTodayMaxDate
                    :error="errors[`vaccinations_history.${index}.date_received`] ? errors[`vaccinations_history.${index}.date_received`][0] : ''"
                />
            </div>
        </div>
        
        <p v-if="!disableInputs" @click="addRow" class="font-bold text-primary-500 hover:text-primary-700 transition cursor-pointer text-sm w-fit">
            Add another +
        </p>
    </div>
</template>

<script setup lang="ts">
import TextInput from '@/components/inputs/TextInput.vue';
import CalendarPicker from '@/components/CalendarPicker.vue';
import { numberonly } from '@/helpers/NumberHelper';
import { ref } from 'vue';
import { onKeypressNumbersOnly, onPasteNumbersOnly } from '@/helpers/ValidationHelpers';

const props = defineProps({
    form: {
        type: Object,
        required: true
    },
    disableInputs: {
        type: Boolean,
        required: false
    },
    errors: {
        type: Array,
        required: true
    },
})

const item = ref(props.form)

const addRow = () => {
    item.value.push({
        vaccine_type: null,
        brand_name: null,
        number_of_doses: null,
        date_received: null,
    })
}

const remove = (index: string) => {
    item.value.splice(index, 1);
}
</script>